import React, { useState, useEffect, useRef, useContext } from 'react'
import { injectIntl } from 'react-intl'
import { Form, Input, Button, Modal } from 'antd'

import LinkPay from './LinkPay';
import QrcodePay from './QrcodePay';
import myContext from '@/utils/createContext'

const FormItem = Form.Item

const CommonQrcodeOrLink = props => {
    const { payMethods, urlParams, payData, infoData, intl, prePayment } = props;
    const { isMobileView, loading, actualPaymentAmount, setLoading, actualPaymentCurrency, publicKey, key, token, type, checkPolling, orderStatus } = useContext(myContext)

    console.log(type);
    return (
        <myContext.Provider value={{
            payMethods,
            urlParams,
            isMobile: isMobileView,
            checkPolling,
            payData,
            infoData,
            setLoading,
            intl,
            loading,
            actualPaymentAmount,
            actualPaymentCurrency,
            publicKey,
            key,
            token,
            type,
            checkPolling,
            orderStatus
        }}>
            {/* 移动端link跳转， pc端二维码， */}
            {isMobileView ? <LinkPay prePayment={prePayment}/> : <QrcodePay prePayment={prePayment}/>}
        </myContext.Provider>
    )
}

export default injectIntl(CommonQrcodeOrLink)
